import { render, staticRenderFns } from "./ShareNews.vue?vue&type=template&id=86b15814&"
import script from "./ShareNews.vue?vue&type=script&lang=js&"
export * from "./ShareNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports